import React from "react";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../assets/background.jpg"; // Placeholder for background image
import datascience from "../assets/course/datascience.jpg";
import devops from "../assets/course/devops.jpeg";
import django from "../assets/course/django.jpg";
import flutter from "../assets/course/flutter.png";
import mern from "../assets/course/mern.png";
import python from "../assets/course/python.png";
import uiux from "../assets/course/uiux.jpg";
import webdev from "../assets/course/webdev.png";
import reactnative from "../assets/course/reactnative.png";
import ai from "../assets/course/ai.png";
import java from "../assets/course/java.png";
import digitalmarketing from "../assets/course/digitalmarketing.jpg";
import rhcsa from "../assets/course/rhcsa.jpeg";
import rhce from "../assets/course/rhce.png";
import oracle from "../assets/course/oracle.png";
import aiml from "../assets/course/aiml.png";
import ccna from "../assets/course/ccna.jpg";
import ccnp from "../assets/course/ccnp.jpg";
import { FaWhatsapp } from "react-icons/fa";

const courses = [
  {
    title: "Full Stack MERN",
    duration: "45 days",
    image: mern,
    path: "/courses/full-stack-mern",
  },
  {
    title: "React Native",
    duration: "45 days",
    image: reactnative,
    path: "/courses/react-native",
  },
  {
    title: "Python",
    duration: "30 days",
    image: python,
    path: "/courses/python",
  },
  {
    title: "Data Science",
    duration: "30 days",
    image: datascience,
    path: "/courses/data-science",
  },
  {
    title: "Django",
    duration: "45 days",
    image: django,
    path: "/courses/django",
  },
  {
    title: "DevOps",
    duration: "30 days",
    image: devops,
    path: "/courses/devops",
  },
  {
    title: "Flutter App Development",
    duration: "45 days",
    image: flutter,
    path: "/courses/flutter-app-development",
  },
  {
    title: "UI/UX Design",
    duration: "30 days",
    image: uiux,
    path: "/courses/uiux-design",
  },
  {
    title: "Frontend Web Development",
    duration: "30 days",
    image: webdev,
    path: "/courses/frontend-web-development",
  },
  {
    title: "Full Stack Java",
    duration: "30 days",
    image: java,
    path: "/courses/full-stack-java",
  },
  {
    title: "Digital Marketing",
    duration: "30 days",
    image: digitalmarketing,
    path: "/courses/digital-marketing",
  },
  {
    title: "AI",
    duration: "30 days",
    image: ai,
    path: "/courses/ai",
  },
  {
    title: "RHCSA",
    duration: "45 days",
    image: rhcsa,
    path: "/courses/rhcsa",
  },
  {
    title: "RHCE",
    duration: "45 days",
    image: rhce,
    path: "/courses/rhce",
  },
  {
    title: "Oracle DB",
    duration: "45 days",
    image: oracle,
    path: "/courses/oracle",
  },
  {
    title: "AI & ML",
    duration: "60 days",
    image: aiml,
    path: "/courses/aiml",
  },
  {
    title: "CCNA",
    duration: "30 days",
    image: ccna,
    path: "/courses/ccna",
  },
  {
    title: "CCNP",
    duration: "45 days",
    image: ccnp,
    path: "/courses/ccnp",
  },
];

const Courses = () => {
  const navigate = useNavigate();

  const handleReadMore = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  };

  return (
    <div
      className="relative min-h-screen text-white"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#1e3a8a",
        background: `linear-gradient(135deg, rgba(30, 58, 138, 0.8), rgba(6, 182, 212, 0.8)), url(${backgroundImage})`,
      }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {courses.map((course, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-lg shadow-md overflow-hidden transform transition-transform duration-300 hover:scale-105 hover:-translate-y-2"
            >
              <img
                src={course.image}
                alt={course.title}
                className="w-full h-40 sm:h-48 object-cover"
              />
              <div className="p-4 sm:p-6">
                <h3 className="text-lg sm:text-xl font-semibold text-white">
                  {course.title}
                </h3>
                <p className="text-gray-200 mt-2 text-sm sm:text-base">
                  Duration: {course.duration}
                </p>
                <button
                  onClick={() => handleReadMore(course.path)}
                  className="mt-4 w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition-colors text-sm sm:text-base"
                >
                  Read More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/9779849489441"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 sm:right-6 top-1/2 transform -translate-y-1/2 bg-green-500 text-white p-3 sm:p-4 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300 z-50"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="w-6 h-6 animate-spin-slow" />
      </a>

      {/* Inline CSS for Animations and Responsive Adjustments */}
      <style>
        {`
          @keyframes spin-slow {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .animate-spin-slow {
            animation: spin-slow 4s linear infinite;
          }
          .hover\\:scale-105:hover {
            transform: scale(1.05);
          }

          /* Disable fixed background on mobile for performance */
          @media (max-width: 640px) {
            div[style*="background-attachment: fixed"] {
              background-attachment: scroll;
            }
            .fixed.right-4.sm\\:right-6 {
              right: 2rem;
              padding: 0.75rem;
            }
            .fixed.right-4.sm\\:right-6 .w-6.h-6 {
              width: 1.25rem;
              height: 1.25rem;
            }
            .grid > div {
              margin-bottom: 1.5rem;
            }
            .grid img {
              height: 10rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Courses;
